import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, CircularProgress, Container, Stack, Card, CardMedia, CardContent, Divider } from "@mui/material";
import { FormattedDate } from "react-intl";
import { competitionsPublicRoute } from "network/api-routes";
import performRequest from "network/perform-request";
import RevaText from "components/common/RevaText";
import SortableTournamentList from "components/common/SortableTournamentList";
import ErrorPage from "../ErrorPages/404";
import DownloadAppCTA from "components/common/DownloadAppCTA";

export default function EventDetail() {
  const { eventUUID } = useParams();
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    performRequest("POST", competitionsPublicRoute, { competition_uuid: eventUUID }, false, null)
      .then((res) => setEvent(res.data))
      .catch((err) => {
        if (err.response?.status === 404) {
          setError(true);
        } else {
          // manejar otro tipo de error
        }
      });
    //   .finally(() => setLoading(false));
  }, [eventUUID]);

  if (error) return <ErrorPage />;

  if (!event) {
    return <CircularProgress />;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Stack direction={{ xs: "column", md: "row" }}>
        <Stack>
          {/* Banner */}
          <Box
            component="img"
            src={event.full_banner_url}
            sx={{
              aspectRatio: 4 / 5,
              objectFit: "cover",
              width: { xs: "100%", md: 400, backgroundColor: "black", borderRadius: 10 },
            }}
            alt={event.name}
          />
          {/* Clubes desktop */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Divider sx={{ my: 3 }} />
            <RevaText id="Clubes donde se juega" variant="h5" />
            {event.establishments.map((club) => (
              <Card sx={{ mt: 2 }} key={club.id}>
                <CardMedia component="img" height="140" image={club.full_banner_url} alt={club.public_name} />
                <CardContent sx={{ height: "max-content" }}>
                  <RevaText gutterBottom variant="h4" component="div">
                    {club.public_name}
                  </RevaText>
                  <RevaText variant="caption">{club.address}</RevaText>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Stack>

        <Stack direction="column" sx={{ pt: { xs: 4, md: 2 }, pl: { md: 4 }, width: "100%" }}>
          {/* Info principal */}
          <RevaText variant="h5" color="text.secondary" id="Evento" />
          <RevaText variant="h3" sx={{ mt: 1 }}>
            {event.name}
          </RevaText>
          {event.description && (
            <RevaText color="text.secondary" sx={{ mt: 1 }}>
              {event.description}
            </RevaText>
          )}
          {/* Organización */}
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Stack sx={{ width: "50%" }}>
              <RevaText id="Organizador por" variant="h5" sx={{ mt: 2 }} />
              <RevaText color="text.secondary" sx={{ mt: 1 }}>
                {event.organizer}
              </RevaText>
            </Stack>
            <Stack sx={{ width: "50%" }}>
              <RevaText id="Contacto" variant="h5" sx={{ mt: 2 }} />
              <RevaText color="text.secondary" sx={{ mt: 1 }}>
                {event.organizer_phone || "-"}
              </RevaText>
            </Stack>
          </Stack>
          {/* Fechas */}
          <Stack direction="row">
            <Stack sx={{ width: "50%" }}>
              <RevaText id="Fecha de inicio" variant="h5" sx={{ mt: 2 }} />
              <RevaText color="text.secondary" sx={{ mt: 1 }}>
                <FormattedDate value={new Date(event.start_at)} year="numeric" month="long" day="numeric" />
              </RevaText>
            </Stack>
            <Stack sx={{ width: "50%" }}>
              <RevaText id="Fecha de fin" variant="h5" sx={{ mt: 2 }} />
              <RevaText color="text.secondary" sx={{ mt: 1 }}>
                <FormattedDate value={new Date(event.end_at)} year="numeric" month="long" day="numeric" />
              </RevaText>
            </Stack>
          </Stack>
          <Divider sx={{ my: 3 }} />
          {/* Torneos del evento */}
          <RevaText id="Torneos" variant="h5" sx={{ mb: 2 }} />
          <SortableTournamentList tournaments={event.tournaments} disabled={true} />
        </Stack>
      </Stack>
      {/* Clubes mobile */}
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Divider sx={{ my: 3 }} />
        <RevaText id="Clubes donde se juega" variant="h5" />
        {event.establishments.map((club) => (
          <Card sx={{ mt: 2 }} key={club.id}>
            <CardMedia component="img" height="140" image={club.full_banner_url} alt={club.public_name} />
            <CardContent sx={{ height: "max-content" }}>
              <RevaText gutterBottom variant="h4" component="div">
                {club.public_name}
              </RevaText>
              <RevaText variant="caption">{club.address}</RevaText>
            </CardContent>
          </Card>
        ))}
      </Box>
      <DownloadAppCTA />
    </Container>
  );
}
